import axios from '~/clients/axios';
import { NEW_CAR_CONFIGURATION } from '~/constants/endpoints';
import type {
  ConfigurationRequest,
  ResponseForRequest
} from '~/contracts/new-cars';
import pickRequestProps from '~/utilities/new-cars/pickRequestProps';

export default function fetchNewCarConfiguration<
  R extends ConfigurationRequest
>(request: R, controller: AbortController): Promise<ResponseForRequest<R>> {
  return axios
    .post(NEW_CAR_CONFIGURATION, pickRequestProps(request), {
      signal: controller.signal
    })
    .then(res => res.data);
}
